/**
 * personal management
 */
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userAction from '../../../actions/userAction'
import * as commonAction from '../../../actions/commonAction'
import * as baseAction from '../../../actions/baseAction'
import RichHeader from '../RichHeader.jsx';
import Bulletins from '../fragment/Bulletins.jsx'
import { DOMAIN } from '../../../constants/config';
import Footer from '../../../components/footers/Original_Main.jsx';
import Popup from '../../../components/modal/popup.jsx'
import * as REG from '../../../constants/regulars';
import * as reportAction from "../../../actions/reportAction";
import UsdtWithdrawal from './popPage/UsdtWithdrawal.jsx'
import BindDigitalWallet from './popPage/BindDigitalWallet.jsx'
class PersonalIndex extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.refreshBalance = this.refreshBalance.bind(this);
    this.toggleNotice = this.toggleNotice.bind(this);
    this.toggleTransfer = this.toggleTransfer.bind(this);
    this.transferMoney = this.transferMoney.bind(this);
    this.state = {
      modal: null,
      showNotice: false,
      showTransfer: false,
      loading: null,
      domainName: false,
      showPickWithdrawal: false,
      showUsdtWindow: false,
      showBindDigitalWallet: false,
      hasGooglePwd: false,
    };
  }

  componentDidMount() {
    // 获取第一页公告信息
    this.props.$$COMMON.getBulletins(1);
    // 获取4个平台的余额
    this.props.$$USER.getPlatformBalance("pt");
    this.props.$$USER.getPlatformBalance("ag");
    this.props.$$USER.getPlatformBalance("bbin");
    this.props.$$USER.getPlatformBalance("ibc");
    this.props.$$USER.getPlatformBalance("wali");
    this.props.$$USER.getPlatformBalance("yy");
    this.props.$$USER.getPlatformBalance("kgame");
    this.setState({
      domainName: window.location.hostname.indexOf("hengy800") !== -1,
    });
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  // 刷新平台余额
  refreshBalance(platfrom) {
    platfrom === "lottery" ? this.props.$$USER.getLotteryBalance() : this.props.$$USER.getPlatformBalance(platfrom);

    this.setState({
      loading: platfrom,
    });

    this.timer = setTimeout(() => {
      this.setState({
        loading: null,
      });
    }, 800);
  }
  showUsdtWindow() {
    this.props.$$USER.checkUsdtAvailable((e) => {
      if (e.data.is_enable == true) {
        this.setState({
          showPickWithdrawal: false,
          showUsdtWindow: true,
          hasGooglePwd: e.data.is_enable_two_fa,
        });
      } else {
        this.props.$$BASE.openAlert("USDT提款不可用!");
      }
    });
  }
  // transfer
  transferMoney(money, _from, _to) {
    this.props.$$USER.transferBalance(_to, _from, money);
    this.toggleTransfer(false);
  }

  // 打开弹出框
  openModal(url, title, width, height) {
    this.props.$$BASE.openIframeModal(url, title, width, height);
  }

  // 打开关闭公告
  toggleNotice(status) {
    this.setState({
      showNotice: status,
    });
  }

  // 打开关闭转账
  toggleTransfer(status) {
    this.setState({
      showTransfer: status,
    });
  }

  render() {
    const __user = this.props.__USER.toJS();
    const __base = this.props.__BASE.toJS();
    const { info, balance, platform_profile } = __user;
    const { domainName } = this.state;
    return (
      <div className="personal-container report-commer-container">
        <div className="personal-l">
          <dl>
            <dt>{info.username ? info.username.toUpperCase().substring(0, 2) : null}</dt>
            <dd>{info.username}</dd>
          </dl>
          <ul>
            <li>
              nickname：<span>{info.nickname}</span>
              <i onClick={this.openModal.bind(this, "user/changename?width=1050", "完善资料", 800, 500)}></i>
            </li>
            {/* <li>预留信息：<span>{info.preinfo || '建议填写'}</span><i onClick={this.openModal.bind(this, 'user/changename?width=1050', '完善资料', 800, 500)}></i></li>
            <li>彩票返点：<strong>{info.rebate_percentage}</strong>
              <a className='pointer' onClick={this.openModal.bind(this, 'user/userset?width=1050', '彩票信息', 1040, 580)}>彩票信息</a>
            </li> */}
          </ul>
        </div>
        <div className="personal-r">
          <ul className="typeUl clear">
            <li className="active">
              <span>lottery</span>
              <dl>
                <dt>the account balance of the lottery</dt>
                <dd>
                  <strong>{_.round(balance.lottery, 4).toFixed(4)}</strong>
                  <i
                    className={this.state.loading == "lottery" ? "active" : ""}
                    onClick={this.refreshBalance.bind(this, "lottery")}></i>
                </dd>
              </dl>
            </li>
            {/* <li>
                    <span>PT</span>
                    <dl>
                        <dt>PT余额</dt>
                        <dd><strong>{!platform_profile['pt'].available ? <em>{platform_profile['pt'].message}</em> : _.round(balance.pt, 4).toFixed(4)}</strong><i className = {this.state.loading == 'pt' ?'active':''} onClick={this.refreshBalance.bind(this, 'pt')}></i></dd>
                    </dl>
                </li>
                <li style={{display:domainName?'none':''}}>
                    <span>AG</span>
                    <dl>
                        <dt>AG余额</dt>
                        <dd><strong>{!platform_profile['ag'].available ? <em>{platform_profile['ag'].message}</em> : _.round(balance.ag, 4).toFixed(4)}</strong><i className = {this.state.loading == 'ag' ?'active':''} onClick={this.refreshBalance.bind(this, 'ag')}></i></dd>
                    </dl>
                </li>
                <li style={{marginRight:domainName?'0px':'16px'}}>
                    <span>BB</span>
                    <dl>
                        <dt>BBIN余额</dt>
                        <dd><strong>{!platform_profile['bbin'].available ? <em>{platform_profile['bbin'].message}</em> :_.round(balance.bbin, 4).toFixed(4)}</strong><i className = {this.state.loading == 'bbin' ?'active':''} onClick={this.refreshBalance.bind(this, 'bbin')}></i></dd>
                    </dl>
                </li>
                <li>
                    <span>沙</span>
                    <dl>
                        <dt>沙巴余额</dt>
                        <dd><strong>{!platform_profile['ibc'].available ? <em>{platform_profile['ibc'].message}</em> : _.round(balance.ibc, 4).toFixed(4)}</strong><i className = {this.state.loading == 'ibc' ?'active':''} onClick={this.refreshBalance.bind(this, 'ibc')}></i></dd>
                    </dl>
                </li>
                <li>
                    <span>云</span>
                    <dl>
                        <dt>云游棋牌余额</dt>
                        <dd><strong>{!platform_profile['yy'].available ? <em>{platform_profile['yy'].message}</em> : _.round(balance.yy, 4).toFixed(4)}</strong><i className = {this.state.loading == 'yy' ?'active':''} onClick={this.refreshBalance.bind(this, 'yy')}></i></dd>
                    </dl>
                </li>
                <li>
                    <span>WALI</span>
                    <dl>
                        <dt>瓦力棋牌余额</dt>
                        <dd><strong>{!platform_profile['wali'].available ? <em>{platform_profile['wali'].message}</em> : _.round(balance.wali, 4).toFixed(4)}</strong><i className = {this.state.loading == 'wali' ?'active':''} onClick={this.refreshBalance.bind(this, 'wali')}></i></dd>
                    </dl>
                </li>
                <li>
                    <span>KG</span>
                    <dl>
                        <dt>KGAME余额</dt>
                        <dd><strong>{!platform_profile['kgame'].available ? <em>{platform_profile['kgame'].message}</em> : _.round(balance.kgame, 4).toFixed(4)}</strong><i className = {this.state.loading == 'kgame' ?'active':''} onClick={this.refreshBalance.bind(this, 'kgame')}></i></dd>
                    </dl>
                </li> */}
          </ul>
          <ul className="btnUl">
            <li onClick={this.openModal.bind(this, "emaildeposit/main", "recharge", 1040, 740)}>
              <i className="recharge"></i>
              <span>recharge</span>
            </li>
            <li onClick={() => this.setState({ showPickWithdrawal: true })}>
              <i className="withdrawal"></i>
              <span>withdrawal</span>
            </li>
            <li onClick={this.toggleTransfer.bind(this, true)}>
              <i className="transfer"></i>
              <span>transfer</span>
            </li>
            <li onClick={this.openModal.bind(this, "report/fundreport", "transfer record", 1040, 580)}>
              <span>transfer record&gt;&gt;</span>
            </li>
          </ul>
        </div>
        <div className="cf"></div>
        <ul className="settingBtn">
          <li>
            <span className="login-password"></span>
            <dl>
              <dt>login password</dt>
              <dd>6-16 characters</dd>
            </dl>
            <a
              className="pointer"
              onClick={this.openModal.bind(this, "user/changeloginpass?type=login", " change login password", 820, 500)}>
              change login password
            </a>
          </li>
          <li>
            <span className="bind-card"></span>
            <dl>
              <dt>bind bank card</dt>
              <dd>up to 5 bank cards can be bound</dd>
            </dl>
            <a
              className="pointer"
              onClick={this.openModal.bind(this, "user/userbankinfo?width=1050", "bind bank card", 820, 550)}>
              bind bank card
            </a>
          </li>
          <li>
            <span className="bind-card"></span>
            <dl>
              <dt>digital wallet</dt>
              <dd>up to 5 digital wallets can be bound</dd>
            </dl>
            <a className="pointer" onClick={() => this.setState({ showBindDigitalWallet: true })}>
              bind digital wallet
            </a>
          </li>
          <li>
            <span className="funding-password"></span>
            <dl>
              <dt>
                withdrawal password
                {!info.has_securitypwd ? <em>unset</em> : null}
              </dt>
              <dd>6-16 characters</dd>
            </dl>
            <a
              className="pointer"
              onClick={this.openModal.bind(
                this,
                "user/changeloginpass?type=prize",
                info.has_securitypwd ? "change withdrawal password" : "set withdrawal password",
                820,
                500
              )}>
              {info.has_securitypwd ? "change" : "set"}withdraw password
            </a>
          </li>
          {/* <li>
            <span className="station-letter"></span>
            <dl>
              <dt>站内信</dt>
              <dd><i>{info.messages}</i>条未读</dd>
            </dl>
            <a className='pointer' onClick={this.openModal.bind(this, 'user/messages', '查看站内信', 900, 610)}>查看站内信</a>
          </li>
          <li>
            <span className="security-settings"></span>
            <dl>
              <dt>密保设定</dt>
              <dd>用于找回密码</dd>
            </dl>
            <a className='pointer' onClick={this.openModal.bind(this, 'user/bindsequestion?width=1050', '密保设定', 820, 560)}>修改密保设定</a>
          </li>
          <li>
            <span className="notice"></span>
            <dl>
              <dt>公告</dt>
              <dd>请随时关注最新公告</dd>
            </dl>
            <a className='pointer' onClick={this.toggleNotice.bind(this, true)}>查看公告</a>
          </li> */}
        </ul>
        <div className="clearfix"></div>
        <Popup
          display={this.state.showPickWithdrawal}
          width={820}
          height={500}
          onclose={() => this.setState({ showPickWithdrawal: false })}>
          <div className="modal-title">withdraw</div>
          <div className="pick-withdrawal-window">
            <p className="top-text">Please select withdrawal method</p>
            {__user.withdraw_type_data.status == true && (
              <div>
                <p
                  className="pick-btn"
                  onClick={() =>
                    this.props.$$BASE.openIframeModal(
                      "emaildeposit/main?controller=security&action=platwithdraw&isiframe=1",
                      "withdraw",
                      820,
                      600
                    )
                  }>
                  <span className="tip">bonus since 0.1%</span>
                  <span>极速提款1</span>
                </p>
              </div>
            )}
            {__user.withdraw_type_data.status == false && (
              <div>
                <p
                  className="pick-btn"
                  onClick={() =>
                    this.props.$$BASE.openIframeModal(
                      "emaildeposit/main?controller=security&action=platwithdraw&isiframe=1",
                      "提款",
                      820,
                      600
                    )
                  }>
                  <span className="tip">bonus since 0.1%</span>
                  <span>极速提款1</span>
                </p>
              </div>
            )}
            {/* <p className="text-1">可用提款余额共计：{__user.withdraw_type_data.availablebalance}元，其中{__user.withdraw_type_data.digitalrest}元可以使用USDT提款取出</p>
                  <p className="process-text">USDT介绍及提款流程</p> */}
          </div>
        </Popup>
        <Popup
          display={this.state.showUsdtWindow}
          width={820}
          className="notice"
          height={567}
          onclose={() => this.setState({ showUsdtWindow: false })}>
          <UsdtWithdrawal onclose={() => this.setState({ showUsdtWindow: false })} hasGooglePwd={this.state.hasGooglePwd} />
        </Popup>
        <Popup
          display={this.state.showBindDigitalWallet}
          width={820}
          className="notice"
          height={567}
          onclose={() => this.setState({ showBindDigitalWallet: false })}>
          <BindDigitalWallet />
        </Popup>
        <Popup
          display={this.state.showNotice}
          width={980}
          className="indexPobup"
          height={567}
          onclose={this.toggleNotice.bind(this, false)}>
          <Bulletins notice={this.state.notice} />
        </Popup>
        <Popup display={this.state.showTransfer} width={980} height={567} onclose={this.toggleTransfer.bind(this, false)}>
          <div className="modal-title">transfer</div>
          <TransMoneyModal balance={balance} handleSubmit={this.transferMoney.bind(this)} />
        </Popup>
      </div>
    );
  }
}

reactMixin(PersonalIndex.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __USER: state.user,
	__REPORT:state.report
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$USER: bindActionCreators(userAction, dispatch),
    $$COMMON: bindActionCreators(commonAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch),
	$$REPORT:bindActionCreators(reportAction, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalIndex)


/**
 * 转账表单
 */
class TransMoneyModal extends React.Component{

  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleTransfer = this.handleTransfer.bind(this);
    this.state={
      fromList: ['lottery', 'pt', 'ag', 'bbin', 'ibc', 'yy', 'wali', 'kgame'],
      toList: ['pt', 'ag', 'bbin', 'ibc','yy', 'wali', 'kgame'],
      transferFrom:'lottery',
      transferTo:'pt',
        domainName:false
    }
    // 字典
    this.platfroms = {
      lottery: {name: '彩票', abb: '彩', type: 'lottery'},
      pt: {name: 'PT', abb: 'PT', type: 'games'},
      ag: {name: 'AG', abb: 'AG', type: 'games'},
      bbin: {name: 'BBIN', abb: 'BB', type: 'games'},
      ibc: {name: '沙巴', abb: '沙', type: 'games'},
      yy: {name: '云游棋牌', abb: 'YY', type: 'games'},
      wali: {name: '瓦力棋牌', abb: 'WALI', type: 'games'},
      kgame: {name: 'KGAME', abb: 'KGAME', type: 'games'}
    }
  }

  componentDidMount() {
      this.setState({
          domainName:window.location.hostname.indexOf('hengy800')!==-1
      })
  }

    /**
   * 选中操作
   * @param  {[type]} 点击平台          [description]
   * @param  {[type]} 是否点击的是转出  [description]
   */
  handleSelect(platfrom, isFrom){
    // 点击的转入账户
    if (!isFrom) {
      this.setState({
        transferTo: platfrom
      })
      return
    }
    // 点击的转出账户
    if (platfrom == this.state.transferFrom) {
      return;
    }
    // 点击的平台
    if (this.platfroms[platfrom].type == 'games') {
      this.setState({
        toList: ['lottery'],
        transferFrom: platfrom,
        transferTo: 'lottery'
      })
      return;
    }

    // 点击的彩票
    if (this.platfroms[platfrom].type == 'lottery') {
      this.setState({
        toList: ['pt', 'ag', 'ibc', 'yy', 'wali', 'kgame'],
        transferFrom: platfrom,
        transferTo: 'pt'
      })
    }
  }

  /**
   * 确认提交转账
   * @return {[type]} [description]
   */
  handleTransfer(){
    const { handleSubmit } = this.props;
    const transMoney = ReactDOM.findDOMNode( this.refs.balance ).value;
    if (!REG.MONEY.test(transMoney)) {
      alert('请输入正确的转账金额');
      return;
    }
    handleSubmit(transMoney, this.state.transferFrom, this.state.transferTo);
  }

  render(){
    const { balance } = this.props;
    const {domainName}=this.state
    return (
      <div className='trans-money-modal-container'>
        <h4>转出账户：</h4>
        <ul>
          {
            this.state.fromList.map((item, index) =>
                <li style={{display:(item==='ag' && domainName === true) ?'none':''}} key={index} className={this.state.transferFrom == item ? "active pointer" : "pointer" } onClick={this.handleSelect.bind(this, item, true)} >
                    <span>{this.platfroms[item].abb}</span>
                    <dl>
                        <dt>{this.platfroms[item].name}余额</dt>
                        <dd><strong>{balance[item]}</strong></dd>
                    </dl>
                </li>
            )
          }
        </ul>
        <div className="cf"></div>
        <h4>转入账户：</h4>
        <ul>
          {
            this.state.toList.map((item, index) =>
                <li style={{display:(item==='ag' && domainName === true) ?'none':''}} key={index} className={this.state.transferTo == item ? "active pointer" : "pointer" } onClick={this.handleSelect.bind(this, item, false)} >
                        <span>{this.platfroms[item].abb}</span>
                        <dl>
                            <dt>{this.platfroms[item].name}余额</dt>
                            <dd><strong>{balance[item]}</strong></dd>
                        </dl>
                    </li>
            )
          }
        </ul>
        <div className="cf"></div>
        <div className="enter-box">
          <span>转账金额：</span>
          <input type="text" ref="balance"/>
          <span>元</span>
          <input type="button" className='pointer' onClick={this.handleTransfer} value="确认" />
        </div>
      </div>
    )
  }

}
